export const userIDS = [
    {id: "1rXCRZVwaZc6ZVs5rR5lojcrvZH3", name: "maik.s"},
    {id: "pNY0vOs7nEUdPpEeOM8A8HIl4u83", name: "rhea.br-f"},
    {id: "8QPA313v0hQBsjFuAr3kT8MNLvZ2", name: "christian.f"},
    {id: "maf75CWbcNYRF0Xdoz4vUaFlp9w1", name: "dominik.he"},
    {id: "cb0z7dSxX6fUq4toW0jUbpVZFxA2", name: "elena.b"},
    {id: "Dm3Wb7Uz8sQdi0H8YOBAB15f3xd2", name: "rr-h"},
    {id: "-", name: "-"},
    {id: "N8k74sxfHbV3GRJKZClBw62DFKC2", name: "sf5mkD"},
    {id: "AZILPmzAIJQ0M6Q6cqX3fC5ofTA2", name: "sf11ysswe"},
    {id: "qM06FxHgjNTL40anofRMAz1yrxi1", name: "6hhe3"},
    {id: "KE27JXWK9PSPdqlYxOtLRbRh13r2", name: "sf88ued"},
    {id: "XQw5Q4i0lLOanFy9pHZCz8kg82p1", name: "sf5thgbs"},
    {id: "o4HUwD2OjFbpTagRWvVoav1KuEg1", name: "sf6twsa"},
    {id: "FQmcbXtkE1hIomu199FaF9cYFN22", name: "887jkop"},
    {id: "cZUCrq0GCPTsdqbRH8fIBiNdwef1", name: "sf10pkjd"},
    {id: "nhqJaiL2bjQpxuuiGlXlxiclhvW2", name: "sf52x3"},
    {id: "GIzYXTxQDMek9hRHlktu1tla4lx1", name: "sf9prx"},
    {id: "-", name: "-"},
    {id: "JaXdKQsXQ8XbImZWRN2lolDoOEA2", name: "Jan"},
    {id: "-", name: "-"},
    {"id": "4Xai4NV6Q1STnEaAoFIAP6lyF1m2", "name": "p1"},
    {"id": "8q7YGvrkY6Ue0mAG0bNDFhpqj832", "name": "p2"},
    {"id": "jbW4opvHhdaNHIeRghT3iSKRxuY2", "name": "p3"},
    {"id": "KEwLeAV7s8RgsVpMipp7pe42KRG3", "name": "p4"},
    {"id": "tM8kAwpXP4cozJaHPKfhUivXIHh2", "name": "p5"},
    {"id": "Xpcdeu8nxWMTG1UFVz4bUbTFqY22", "name": "p6"},
    {"id": "yeog2LcTpIMfE2my2FjKPAb7DdA2", "name": "p7"},
    {"id": "z02BhLVqJuWY2RkSlo4VQRx1Isg2", "name": "p8"},
    {"id": "wOkA8hNRiGfIwl6aOKu6kS1DxrO2", name: "p9 - 3 Tage"},

    {id: "-", name: "-"},


    {"id": "-", name: "-"},
    {"id": "fkHcQeDMgGelP6pv7ef1MNLvMRy2", "name": "s1"},
    {"id": "AeHDxiGLztQsyMvAzTcXDskqQf33", "name": "s2"},
    {"id": "olOsvAdzsMQk2rcgWIvVTZDG77q2", "name": "s3"},
    {"id": "ZdBgSlXMhtM132Jas1JzGISUzrE3", "name": "s4"},
    {"id": "62UGkjGsmMgRV1BK1xJcCdDOsYC2", "name": "s5"},
    {"id": "RtKYGJl3NWVoasFkuWVT4bipfUq1", "name": "s6"},
    {"id": "aCgS9u2HT0UKIdISwRVXuLac2Xb2", "name": "s9"},

    {"id": "-", name: "-"},

    {"id": "-", name: "-"},

    {"id": "POt7fakXY5U83zMr0O74oIousSx2", name: "steiner@steinerfood.com"},
    {"id": "B3EdWCN84aQRMkwtIEfldCkoPai2", name: "martina.radlbeck@gmx.de"},
    {"id": "cYxSZB40mMP8d1babmODGXWmAvp2", name: "datler@steinerfood.com"},
    {"id": "FgNYDrQUevQtDPmh5KWnO9TRbBC2", name: "inga13a@googlemail.com"},
    {"id": "JHrhu9UyZvRpUlgl1DevO8KOwna2", name: "jradlbeck@t-online.de"},
    {"id": "oZlisuua35aVMORCGOkH4NeW5R93", name: "redheadanna@hotmail.de"},

    {"id": "6RVA6GhNnwdzEbLF3WO5O5iJjiw1", name: "jazzi.z"},

    {"id": "k3Gt7tR3HvNfNN6prFQgkxOzyM73", name: "luise"},
    {"id": "KzgmuLR0DDS6iIgr9NR2FFbdqOi1", name: "markf"},
    {"id": "5g8Mxy9QPDgelQkIel7GIk1gZI83", name: "sascha"},
    {"id": "237jSaKlvlMyyaSWxD6GyodoN273", name: "kevinipohone"},
    {"id": "237jSaKlvlMyyaSWxD6GyodoN273", name: "iphonelocal"},
    {"id": "4h6FKhTsG3bIhZN9o8RFLscpah52", name: "my"},
    {"id": "4DwtTdZl1COBvkld36w9m9HmCE72", name: "lisa"},
    {"id": "Ppnij0sC2ehCU5K0GNbknMJJ5Pm2", name: "md-d1"},
    {"id": "ISr02YziKsdtOiEjJNrVGjCdgFJ2", name: "js"},
    {"id": "7Y8I2M9U7iQrJzMZKTSRFYtfCxm2", name: "sandra"},
    {"id": "pfq8iSp7XecXT7sasQ0WBx1h5yw1", name: "bergam"},
    {"id": "TQ897eAcaEOldtkQlfeDuDy38dU2", name: "diane"},
    {"id": "V1WFI46bR0OpNNW3R0kjqSVPHLX2", name: "faible"},
    {"id": "4tsEkpPvZjNuDkD3kZXaXK8LK052", name: "heppo"},
    {"id": "wvMywocQrTaUT10utnaP43kS1dG3", name: "d"},
    {"id": "D39VMJ9OOZcoPBZdGAVhpwy1Ib72", name: "jb"},
    {"id": "uvIlglKRWnMTxVMJskA4bInK8oy1", name: "mo"},
    {"id": "I5VUWeXYtkTiOAzlbjOjBpgDKGN2", name: "unterl"},
    {"id": "hz1QsJn9KDgTrWWX6qyGoFmrJGr2", name: "egrense"},
    {"id": "54q4pd0ThyPSf7ySdDwqXLuv4082", name: "kuhn"},
    {"id": "CrvGm8nCsoSJxJDPUjTiTR5VnXW2", name: "gerome"},
    {"id": "E09RSle1daZC1flUGK7PixRJLFk2", name: "ranamaus"},
    {"id": "BvQnDVaCL5hyKaHrspoiAY3Kn213", name: "asia"},
    {"id": "l92ByMeDqOU1AwqMmaRAZOz7Zas1", name: "ra"},
    {"id": "3ioTTF1DUWMEQMLLy7h8TATviXH2", name: "diabetoco"},
];


/*    {id: "M73TNAp0iCMAvkOY8ihas0HNNxj2", name: "carstge"},
{id: "0tX7871w7EVIx6wlRGsuDHUvJH13", name: "JH-K"},
{id: "4Xai4NV6Q1STnEaAoFIAP6lyF1m2", name: "AP-K"},
{id: "gRurO8YihFZDjvABnKDjzV4Wctr1", name: "ch-K"},
{id: "-", name: "-"},

 */
